import React, { useEffect, useState } from "react";
import { useWebTranslation } from "../../../translations";
import Gutter from "../../../ui-kit/Gutter";
import DateInput from "../../DateInput/DateInput";
import { Typography } from "../../../ui-kit/Typography";
import { Panel } from "../../../ui-kit/Panels";
import { getLastAllowedStartDate, validStartDate } from "utils/insurance";
import {
  getCompetitorName,
  getCompetitorRenewalDate,
  isCancellationAllowedByCompetitor,
} from "./utils/insurely/insurelyUtil";
import { useCurrentInsuranceByAnimalId } from "../store/selectors/insurance";
import { useCurrentAnimal } from "../store/selectors/animals";
import { useSignupDispatch } from "../store/hooks";
import { updateInsuranceById } from "../store/slices/animals";

const ChooseStartDate = () => {
  const { t } = useWebTranslation();

  const dispatch = useSignupDispatch();
  const { birthday, id } = useCurrentAnimal();
  const insurance = useCurrentInsuranceByAnimalId(id);

  const renewalDate = getCompetitorRenewalDate(insurance.insurely);
  const competitorName = getCompetitorName(insurance.insurely);
  const competitorCancellationAllowed = isCancellationAllowedByCompetitor(
    insurance.insurely
  );
  const [cancelCompetitorPossible, setCancelCompetitorPossible] = useState(
    competitorCancellationAllowed
  );

  useEffect(() => {
    if (
      insurance.insurely?.shouldCompare &&
      competitorCancellationAllowed &&
      insurance.startDate
    ) {
      const renewalDate = getCompetitorRenewalDate(insurance.insurely);
      setCancelCompetitorPossible(renewalDate === insurance.startDate);
    }
  }, [insurance.startDate]);

  return (
    <>
      <Typography variant="h3" color="grey500">
        {t("choose_start_date.title")}
      </Typography>
      <Gutter size={3} />
      <Typography>{t("quote_preview.start_date")}</Typography>
      {insurance.insurely?.shouldCompare ? (
        <>
          <Gutter size={2} />
          <Typography variant="body3">
            {t("choose_start_date.comparison.start_date", {
              competitorName: competitorName ?? "?",
            })}
          </Typography>
          <Gutter size={2} />
        </>
      ) : (
        <Gutter size={3} />
      )}
      <DateInput
        ariaLabel={t("global.start_date")}
        value={insurance.startDate || ""}
        onChange={({ date }) =>
          dispatch(
            updateInsuranceById({
              id: insurance.id,
              update: { startDate: date },
            })
          )
        }
        min={
          new Date(
            validStartDate({
              birthday: birthday ?? "",
              startDate: insurance.startDate,
            })
          )
        }
        max={getLastAllowedStartDate()}
        style={{ fontFamily: "var(--font-eina-semi-bold)" }}
      />
      {insurance.insurely?.shouldCompare &&
        (insurance.insurely.policies?.length ?? 0) > 0 &&
        !cancelCompetitorPossible && (
          <>
            <Gutter size={2} />
            <Panel
              variant="info"
              title={t(
                "choose_start_date.comparison.cancellation_not_possible.title"
              )}
            >
              <Typography variant="body2">
                {competitorCancellationAllowed
                  ? t(
                      "choose_start_date.comparison.cancellation_not_possible.text",
                      {
                        renewalDate: renewalDate ?? "?",
                        competitorName: competitorName ?? "?",
                      }
                    )
                  : t("competitor.comparison.cancellation_not_possible.text", {
                      competitorName: competitorName ?? "?",
                    })}
              </Typography>
            </Panel>
          </>
        )}
    </>
  );
};

export default ChooseStartDate;
